import React from "react";
import TableLogComponents from "../../components/TableLogComponents";
import { left, right } from "../../assets/images";
import DisplayImageTableActivities from "../../components/DisplayImageTableActivities";
import { face_detected, no_image_in_systems } from "../../assets/icons";
import ButtonTrainImage_When_No_ID from '../../components/ButtonTrainImage_When_No_ID'
import Pagination from '../../components/Pagination'
import { useHistory } from "react-router-dom";

export default function TableActivities() {
  const history = useHistory()

  function colorStyleTRTable(data) {
    if(data.name === null) return '#ffeded'
    else return "#FFF"
  }
// test
// test 
  const rowTableLogRealtime = [
    {
      title: "No",
      // dataIndex: "no",
      // key: "no",
      render: (data) => (
        <div style={{ position:'relative' }} >
          {data.name === null && (
           <ButtonTrainImage_When_No_ID dataUser={data} onClick={() => history.push("/activities/train-image-activities/"+data.no)} />
          )}
          {data.name !== null && (
           <p> {data.no} </p>
          )}
        </div>
      ),
      // functionStyleTR : (data) => {
      //   if(data.name === null) return '#ffeded'
      //   else return "#FFF"
      // },
    },
    {
      title: "Image",
      //   dataIndex: "image",
      //   key: "image",
      render: (text) => (
        <DisplayImageTableActivities
          ImageLog={text.imageLog}
          imageTrain={text.imageTrain}
        />
        // <div>
        //   {text.map((data, index) => {
        //     return <p key={index}>{data}</p>;
        //   })}
        // </div>
      ),
    },
    {
      title: "Name",
      //   dataIndex: "name",
      //   key: "name",
      render: (text) => <p>{text.name ? text.name : "N/A"}</p>,
    },
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (text) => <p>{text ? text : "N/A"}</p>,
    },
    {
      title: "Device SN",
      dataIndex: "deviceSN",
      key: "deviceSN",
      render: (text) => <p>{text ? text : "N/A"}</p>,
    },
    {
      title: "Temp",
      dataIndex: "temp",
      key: "temp",
      render: (text) => <p>{text ? text : "N/A"}</p>,
    },
    {
      title: "Class/Room",
      dataIndex: "classRoom",
      key: "classRoom",
      render: (text) => <p>{text ? text : "N/A"}</p>,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (text) => <p>{text ? text : "N/A"}</p>,
    },
    {
      title: "Status",
      // dataIndex: "status",
      // key: "status",
      render: (data) => (
        <div>
          {data.name === null && (
            <img
              src={no_image_in_systems}
              alt="no_image_in_systems"
              style={{ width: "40px" }}
            />
          )}
          {data.name !== null && (
            <img
              src={face_detected}
              alt="face_detected"
              style={{ width: "40px" }}
            />
          )}
        </div>
      ),
    },
  ];

  const columnsTableLogRealtime = [
    {
      no: "122",
      imageLog: null,
      imageTrain: right,
      name: null,
      id: null,
      deviceSN: "SN20200015",
      temp: "36.5",
      classRoom: null,
      date: "14 Dec 2021 11:58:22",
      status: "test status 3",
    },
    {
      no: "123",
      imageLog: null,
      imageTrain: right,
      name: null,
      id: null,
      deviceSN: "SN20200016",
      temp: "37.1",
      classRoom: null,
      date: "14 Dec 2021 11:58:22",
      status: "test status 4",
    },
    {
      name: "Pattarapon",
      date: "14 Dec 2021 11:58:22",
      id: "ID 1",
      no: "1",
      deviceSN: "SN20200015",
      temp: "35.5",
      status: "test status",
      imageLog: left,
      imageTrain: right,
      classRoom: "5/3",
    },
    {
      no: "2",
      imageLog: left,
      imageTrain: right,
      name: "Panudet",
      id: "ID 2",
      deviceSN: "SN20200016",
      temp: "36.5",
      classRoom: "5/3",
      date: "14 Dec 2021 11:58:22",
      status: "test status 2",
    },
    {
      no: "7",
      imageLog: left,
      imageTrain: right,
      name: "Phunara",
      id: "ID 7",
      deviceSN: "SN20200015",
      temp: "34.5",
      classRoom: "5/3",
      date: "14 Dec 2021 11:58:22",
      status: "test status 7",
    },

  ];

  return (
    <div className="box-table-by-nile">
      <TableLogComponents
        columns={rowTableLogRealtime}
        dataSource={columnsTableLogRealtime}
        functionStyleTableRow={colorStyleTRTable}
      />
      <br />
  <div style={{ float:'right' }}>
  <Pagination />
  </div>
    </div>
  );
}
